import mixpanel from 'mixpanel-browser'
import TagManager from 'react-gtm-module'
import ReactGA from 'react-ga'
import Cookies from 'js-cookie'
import { isDev } from '../constants'
import { hotjar } from 'react-hotjar'

const hasAcceptedGA = () => {
  const cookie = Cookies.get('axeptio_authorized_vendors')
  return cookie?.includes('google_analytics') ?? false
}

const hasAcceptedHotjar = () => {
  const cookie = Cookies.get('axeptio_authorized_vendors')
  return cookie?.includes('hotjar') ?? false
}

export const initTracking = () => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN)

  if (!isDev) {
    initHotJAR()
    initGA()
    initGTM()
  }
}

export const track = (event, properties) => {
  if (!isDev) {
    mixpanel.track(event, properties)
    hasAcceptedGA() && ReactGA.event(event)
    hasAcceptedHotjar() && hotjar.event(event)
  }
}

const initHotJAR = () => {
  hasAcceptedHotjar() &&
    process.env.REACT_APP_HOTJAR_HJID &&
    process.env.REACT_APP_HOTJAR_HJSV &&
    hotjar.initialize(process.env.REACT_APP_HOTJAR_HJID, process.env.REACT_APP_HOTJAR_HJSV)
}

const initGA = () => {
  hasAcceptedGA() &&
    process.env.REACT_APP_GA_INIT &&
    ReactGA.initialize(process.env.REACT_APP_GA_INIT)
}

const initGTM = () => {
  process.env.REACT_APP_PUBLIC_GTM_PROPERTY &&
    TagManager.initialize({
      gtmId: process.env.REACT_APP_PUBLIC_GTM_PROPERTY,
    })
}

export default mixpanel
